const UserProfileItem = ({
  id,
  icon,
  label,
  onClick,
  trailingIcon,
  className = "",
  disabled = false,
}) => {
  const isClickable = Boolean(onClick) && !disabled;
  const Icon = icon;
  const TrailingIcon = trailingIcon;

  return (
    <div
      id={id}
      className={`user-profile-item ${isClickable || onClick ? "clickable" : ""} ${className} ${disabled ? "disabled" : ""}`}
      onClick={isClickable ? onClick : undefined}
    >
      <div className="user-profile-item-left">
        {Icon && <Icon className="user-profile-item-icon" />}
        <span className="user-profile-item-label">{label}</span>
      </div>
      {TrailingIcon && <TrailingIcon className="user-profile-item-icon" />}
    </div>
  );
};

export default UserProfileItem;
